import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import { SERVICES, LOCATIONS, EMERGENCIES, problemPaths } from "@/data/seoPages";

const GOLD = "#C7A668";

// Crawlable footer with internal links across all public SEO pages (language-aware).
export default function SeoFooter() {
  const { lang, L } = useLang();
  const en = lang === "en";
  const sBase = en ? "/en/services/" : "/servicios/";
  const lBase = en ? "/en/locations/" : "/ubicaciones/";
  const aboutPath = en ? "/en/about-dukk" : "/sobre-dukk";
  const faqPath = en ? "/en/faq" : "/preguntas-frecuentes";
  const slug = (o) => o[`${lang}Slug`];

  const colTitle = { fontSize: 10.5, letterSpacing: ".12em", color: "#6c727a", marginBottom: 13 };
  const linkStyle = { color: "#B8BDC3", textDecoration: "none", fontSize: 13.5, lineHeight: 2, display: "block" };

  return (
    <footer data-testid="seo-footer" className="footer-solid" style={{ padding: "clamp(36px,4vw,56px) clamp(20px,5vw,64px) 40px", borderTop: "1px solid rgba(255,255,255,.07)", marginTop: "clamp(24px,4vw,48px)" }}>
      <div style={{ maxWidth: 1280, margin: "0 auto", display: "flex", flexWrap: "wrap", gap: 40, justifyContent: "space-between" }}>
        <div style={{ maxWidth: 320 }}>
          <Link to={en ? "/en" : "/"} style={{ textDecoration: "none" }}>
            <svg viewBox="0 0 220 50" height="28" style={{ display: "block", width: "auto" }} fill="none" aria-label="DUKK">
              <g transform="translate(14 9) scale(0.2909)" stroke="#F5F2EE" strokeLinecap="round" fill="none">
                <path d="M5 86C35 72 75 44 118 10" strokeWidth="1.9" />
                <path d="M5 99C35 86 75 58 111 28" strokeWidth="1.9" />
                <path d="M118 10C116 17 113 23 111 28" strokeWidth="1.9" />
                <line x1="0" y1="104" x2="160" y2="104" strokeWidth="1.4" />
              </g>
              <text x="76" y="25" fontFamily="'Cormorant Garamond','Cormorant',Georgia,serif" fontWeight="300" fontSize="28" letterSpacing="8" fill="#F5F2EE">DUKK</text>
            </svg>
          </Link>
          <p style={{ fontSize: 13.5, color: "#9DA1A8", lineHeight: 1.6, margin: "14px 0 0" }}>
            {L("Premium aircraft readiness, cabin care and detailing for private aviation in Mexico.", "Aircraft readiness, cabin care y detailing premium para aviación privada en México.")}
          </p>
        </div>

        <div style={{ display: "flex", gap: 48, flexWrap: "wrap" }}>
          <div>
            <div className="font-mono" style={colTitle}>{L("SERVICES", "SERVICIOS")}</div>
            {SERVICES.map((s) => (
              <Link key={s.key} data-testid={`foot-service-${s.key}`} to={sBase + slug(s)} className="tbnav" style={linkStyle}>{s[lang].h1.split(",")[0].split(":")[0]}</Link>
            ))}
          </div>
          <div>
            <div className="font-mono" style={colTitle}>{L("LOCATIONS", "UBICACIONES")}</div>
            {LOCATIONS.map((l) => (
              <Link key={l.key} data-testid={`foot-location-${l.key}`} to={lBase + slug(l)} className="tbnav" style={linkStyle}>{l[lang].kicker.split("·")[1]?.trim() || l.airport}</Link>
            ))}
          </div>
          <div>
            <div className="font-mono" style={colTitle}>{L("EMERGENCIES", "EMERGENCIAS")}</div>
            {EMERGENCIES.filter((e) => e.type === "emergency").map((e) => (
              <Link key={e.key} data-testid={`foot-emergency-${e.key}`} to={problemPaths(e, lang)} className="tbnav" style={linkStyle}>{e[lang].kicker.split("·")[1]?.trim()}</Link>
            ))}
          </div>
          <div>
            <div className="font-mono" style={colTitle}>dukk</div>
            <Link data-testid="foot-about" to={aboutPath} className="tbnav" style={linkStyle}>{L("About dukk", "Sobre dukk")}</Link>
            <Link data-testid="foot-faq" to={faqPath} className="tbnav" style={linkStyle}>{L("FAQ", "Preguntas frecuentes")}</Link>
            <Link data-testid="foot-membership" to={en ? "/en/membership" : "/membership"} className="tbnav" style={linkStyle}>{L("Membership", "Membresía")}</Link>
            <Link data-testid="foot-sample" to={en ? "/en/sample-report" : "/sample-report"} className="tbnav" style={linkStyle}>{L("Sample report", "Reporte de ejemplo")}</Link>
            <Link data-testid="foot-track" to={en ? "/en/track" : "/track"} className="tbnav" style={linkStyle}>{L("Track status", "Consultar estatus")}</Link>
          </div>
        </div>
      </div>
      <div className="font-mono" style={{ maxWidth: 1280, margin: "40px auto 0", paddingTop: 22, borderTop: "1px solid rgba(255,255,255,.06)", fontSize: 11, color: "#5b616a", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 10 }}>
        <span>© 2026 DUKK®</span>
        <span style={{ color: GOLD }}>{L("Silent service. Visible quality.", "Servicio silencioso. Calidad visible.")}</span>
      </div>
    </footer>
  );
}
